import React, { useState } from "react";

interface MessageProps {
    type: 'success' | 'error' | 'info';
    title?: string;
    okText?: string;
    message: string;
    closeDialog: any;
    handleOk: (reasonValue?: string) => void;
    showCancel?: boolean;
    cancelText?: string;
    handleCancel?: () => void;
    backgroundColor?: string;
    showReasonField?: boolean; // Si se muestra el campo de razón
    reasonLabel?: string;      // Label del campo de razón
    reasonRequired?: boolean;  // Si el campo es requerido, por defecto true
    okWidth?: string;
    children?: React.ReactNode; // contenido adicional debajo del mensaje (ej. un enlace)
}

const Message = ({
    type,
    title = 'Atención',
    okText = 'Ok',
    message,
    closeDialog,
    handleOk,
    showCancel = false,
    cancelText = "Cancelar",
    handleCancel = () => { },
    backgroundColor = "rgba(255,255,255,0.95)",
    showReasonField = false,
    reasonLabel = "Razón",
    reasonRequired = true,
    okWidth = '80px',
    children
}: MessageProps) => {

    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const onOk = () => {
        if (showReasonField && reasonRequired && reason.trim() === '') {
            setError('Este campo es requerido');
            return;
        }
        handleOk(reason);
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: backgroundColor }} tabIndex={-1}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className={`modal-header ${title.length > 0 ? '' : 'visually-hidden'}`}>
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" onClick={closeDialog} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <p
                            style={{
                                whiteSpace: 'pre-line',
                                overflowWrap: 'break-word'
                            }}
                        >
                            {message}
                        </p>
                        {children}

                        {showReasonField &&
                            <div className="mb-3">
                                <label className="form-label">{reasonLabel}{reasonRequired ? '*' : ''}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={reason}
                                    onChange={(e) => { setReason(e.target.value); setError(''); }}
                                />
                                {error && <small className="text-danger">{error}</small>}
                            </div>
                        }

                        <div className="mt-4">

                            {showCancel &&
                                <button
                                    style={{ width: '100px', float: 'left' }}
                                    type="button"
                                    className={"btn btn-outline-danger"}
                                    onClick={handleCancel}
                                >
                                    {cancelText}
                                </button>
                            }

                            <button
                                style={{ width: okWidth, float: 'right' }}
                                type="button"
                                className={type === 'success' ? "btn btn-primary" : "btn btn-danger"}
                                onClick={onOk}
                            >
                                {okText}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Message;
